export enum TimeToSecond {
  Minute = 60,
  Hour = TimeToSecond.Minute * 60,
  Day = TimeToSecond.Hour * 24,
  Week = TimeToSecond.Day * 7,
  Month = TimeToSecond.Day * 31,
  Year = TimeToSecond.Day * 365,
  Forever = Infinity,
}

export enum ByteSize {
  KB = 1024,
  MB = ByteSize.KB * 1024,
  GB = ByteSize.MB * 1024,
  TB = ByteSize.GB * 1024,
  PB = ByteSize.TB * 1024,
}

export enum Direction {
  Top,
  Bottom,
  Left,
  Right,
}

export const BREAD_SLICE_RATIO = 20;
export const CREDIT_USD_RATIO = 1000;

export const POPUP_SCREEN_WIDTH_RATIO = 0.94;

export const NOT_APPLICABLE_STRING = '---';
export const MEMORY_INDEX_PLACEHOLDER_STRING = '----';

export const GOLDEN_RATIO = 1.618034;

export const PASSED_TEMPORAL_UNITS = {
  second: { str: 'count seconds', low: -Infinity, up: 60, base: 1000 },
  minute: { str: 'count minute', low: 60000, up: 60 },
  hour: { str: 'count hours', low: 3600000, up: 24 },
  day: { str: 'count days', low: 86400000, up: 365 },
  year: { str: 'count years', low: 31536000000, up: Infinity },
};
